// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MembersList Page  Premium Dashboard */

.members-page h1 { display: none; }

.members-table-container {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

.members-table-container table {
  width: 100%;
  border-collapse: collapse;
}

.members-table-container thead {
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
}

.members-table-container th {
  padding: 14px 20px;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #64748b;
  text-align: left;
}

.members-table-container td {
  padding: 16px 20px;
  font-size: 0.88rem;
  color: #334155;
  border-bottom: 1px solid #f1f5f9;
}

.members-table-container tr:hover td {
  background: #f8fafc;
}

.members-table-container .btn {
  padding: 6px 14px;
  font-size: 0.78rem;
  border-radius: 6px;
}

.members-table-container .btn-danger {
  background: #fee2e2;
  color: #dc2626;
  border: none;
}

.members-table-container .btn-danger:hover {
  background: #fecaca;
}

.btn-vip {
  background: #f1f5f9;
  color: #94a3b8;
  border: 1px solid #e2e8f0;
  padding: 6px 10px !important;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.btn-vip:hover {
  background: #fef9c3;
  color: #ca8a04;
  border-color: #fde68a;
}

.btn-vip-active {
  background: #fef9c3;
  color: #b45309;
  border: 1px solid #fde68a;
  padding: 6px 10px !important;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.vip-badge {
  display: inline-block;
  margin-left: 8px;
  background: linear-gradient(135deg, #f59e0b, #d97706);
  color: #fff;
  border-radius: 20px;
  padding: 2px 10px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.members-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 16px;
  flex-wrap: wrap;
}

.members-header h1 {
  display: block !important;
  font-size: 1.4rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.members-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.search-input {
  padding: 10px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.88rem;
  width: 280px;
  background: #fff;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.search-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,0.1);
}

.btn-add-visitor {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  background: #3b82f6;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;
}

.btn-add-visitor:hover {
  background: #2563eb;
}

.members-search {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}

.members-search input {
  padding: 10px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.88rem;
  width: 300px;
  background: #fff;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.members-search input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,0.1);
}
`, "",{"version":3,"sources":["webpack://./src/styles/MembersList.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC,mBAAmB,aAAa,EAAE;;AAElC;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,qDAAqD;EACrD,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C","sourcesContent":["/* MembersList Page  Premium Dashboard */\n\n.members-page h1 { display: none; }\n\n.members-table-container {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.members-table-container table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.members-table-container thead {\n  background: #f8fafc;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.members-table-container th {\n  padding: 14px 20px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #64748b;\n  text-align: left;\n}\n\n.members-table-container td {\n  padding: 16px 20px;\n  font-size: 0.88rem;\n  color: #334155;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.members-table-container tr:hover td {\n  background: #f8fafc;\n}\n\n.members-table-container .btn {\n  padding: 6px 14px;\n  font-size: 0.78rem;\n  border-radius: 6px;\n}\n\n.members-table-container .btn-danger {\n  background: #fee2e2;\n  color: #dc2626;\n  border: none;\n}\n\n.members-table-container .btn-danger:hover {\n  background: #fecaca;\n}\n\n.btn-vip {\n  background: #f1f5f9;\n  color: #94a3b8;\n  border: 1px solid #e2e8f0;\n  padding: 6px 10px !important;\n  border-radius: 6px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n}\n\n.btn-vip:hover {\n  background: #fef9c3;\n  color: #ca8a04;\n  border-color: #fde68a;\n}\n\n.btn-vip-active {\n  background: #fef9c3;\n  color: #b45309;\n  border: 1px solid #fde68a;\n  padding: 6px 10px !important;\n  border-radius: 6px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n}\n\n.vip-badge {\n  display: inline-block;\n  margin-left: 8px;\n  background: linear-gradient(135deg, #f59e0b, #d97706);\n  color: #fff;\n  border-radius: 20px;\n  padding: 2px 10px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n.members-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.members-header h1 {\n  display: block !important;\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0;\n}\n\n.members-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.search-input {\n  padding: 10px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 0.88rem;\n  width: 280px;\n  background: #fff;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59,130,246,0.1);\n}\n\n.btn-add-visitor {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px;\n  background: #3b82f6;\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  font-size: 0.88rem;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.2s;\n}\n\n.btn-add-visitor:hover {\n  background: #2563eb;\n}\n\n.members-search {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 16px;\n}\n\n.members-search input {\n  padding: 10px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 0.88rem;\n  width: 300px;\n  background: #fff;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.members-search input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59,130,246,0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
